import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { formatDate } from '../../bank-movements/utils/formatters';

const COMPANY_COLORS = {
  headerBg: '5e894f',
  headerFont: 'FFFFFF',
  evenRow: 'E3E6F3',
  oddRow: 'FFFFFF',
};

export async function exportExchangeChecksToExcel(movements = [], filename = 'ChequesDeCanje.xlsx') {
  if (!Array.isArray(movements) || movements.length === 0) return;

  const columns = [
    { header: 'Cuenta', key: 'account', width: 28 },
    { header: 'Fecha venc.', key: 'due_date', width: 16 },
    { header: 'Fecha emi.', key: 'emission_date', width: 16 },
    { header: 'Tipo', key: 'type', width: 18 },
    { header: 'Concepto', key: 'concept', width: 24 },
    { header: 'N° comp.', key: 'voucher_number', width: 14 },
    { header: 'Beneficiario', key: 'beneficiary', width: 22 },
    { header: 'Importe', key: 'amount', width: 14 },
    { header: 'Saldo Libro', key: 'book_balance', width: 16 },
    { header: 'Saldo Real', key: 'real_balance', width: 16 },
    { header: 'Conciliado', key: 'reconciled', width: 14 },
  ];

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Cheques de Canje');
  worksheet.columns = columns;

  worksheet.getRow(1).eachCell((cell) => {
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: COMPANY_COLORS.headerBg },
    };
    cell.font = {
      color: { argb: COMPANY_COLORS.headerFont },
      bold: true,
      size: 12,
    };
    cell.alignment = { vertical: 'middle', horizontal: 'center' };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
  });

  const toNumber = (value) => {
    if (value === undefined || value === null || value === '') return '';
    if (typeof value === 'number') return value;
    return Number(String(value).replace(/[^0-9.-]/g, ''));
  };

  movements.forEach((movement, idx) => {
    const row = worksheet.addRow({
      account: movement.accountLabel || '',
      due_date: formatDate(movement.due_date),
      emission_date: formatDate(movement.emission_date),
      type: movement.movement_type_name || '',
      concept: movement.concept || '',
      voucher_number:
        movement.voucher_number !== undefined && movement.voucher_number !== null
          ? String(movement.voucher_number)
          : '',
      beneficiary: movement.legal_entity_name || '',
      amount: toNumber(movement.amount),
      book_balance: toNumber(movement.accumulated_balance),
      real_balance: toNumber(movement.accumulated_real_balance),
      reconciled: movement.is_reconciled ? 'Sí' : 'No',
    });

    row.eachCell((cell, colNumber) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: idx % 2 === 0 ? COMPANY_COLORS.evenRow : COMPANY_COLORS.oddRow },
      };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
      cell.border = {
        top: { style: 'thin' },
        bottom: { style: 'thin' },
      };
      if (colNumber >= 8 && colNumber <= 10 && cell.value !== '') {
        cell.numFmt = '[$$-es-AR] #,##0.00';
      }
      if (cell.value === null || cell.value === undefined) {
        cell.value = '';
      }
    });
  });

  worksheet.columns.forEach((col) => {
    col.width = col.width || 16;
  });

  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(
    new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    }),
    filename
  );
}
